export default () => (
  <>
    <option value=''>--</option>
    <option value='Coach House'>Coach House</option>
    <option value='Garden'>Garden</option>
    <option value='Side'>Side</option>
    <option value='Unit'>Unit</option>
    <option value='#'>#</option>
    <option value='Apt'>Apt</option>
    <option value='Apt.'>Apt.</option>
    <option value='BSMT'>BSMT</option>
    <option value='FL'>FL</option>
    <option value='FRNT'>FRNT</option>
    <option value='LOWR'>LOWR</option>
    <option value='RM'>RM</option>
    <option value='STE'>STE</option>
    <option value='UPPR'>UPPR</option>
  </>
);

export const UnitTypes = [
  { cd: '', descr: '--' },
  { cd: 'Coach House', descr: 'Coach House' },
  { cd: 'Garden', descr: 'Garden' },
  { cd: 'Side', descr: 'Side' },
  { cd: 'Unit', descr: 'Unit' },
  { cd: '#', descr: '#' },
  { cd: 'Apt', descr: 'Apt' },
  { cd: 'Apt.', descr: 'Apt.' },
  { cd: 'BSMT', descr: 'BSMT' },
  { cd: 'FL', descr: 'FL' },
  { cd: 'FRNT', descr: 'FRNT' },
  { cd: 'LOWR', descr: 'LOWR' },
  { cd: 'RM', descr: 'RM' },
  { cd: 'STE', descr: 'STE' },
  { cd: 'UPPR', descr: 'UPPR' },
];
